export default {"src":"/_next/static/media/tick-circle.281f104e.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};